export default __webpack_public_path__ + "static/media/swansea-university-logo-white.973d1ea9.svg";